import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a worker-related error
    const errorMessage = error?.message || error?.toString() || '';
    if (errorMessage.includes('sendWithPromise') || 
        errorMessage.includes('sendWithStream') ||
        errorMessage.includes('WorkerTransport') ||
        errorMessage.includes('getOptionalContentConfig') ||
        errorMessage.includes('getStructTree') ||
        errorMessage.includes('streamTextContent') ||
        errorMessage.includes('Cannot read properties of null')) {
      // Suppress worker errors - they don't break the app
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress worker-related errors
    const errorMessage = error?.message || error?.toString() || '';
    if (errorMessage.includes('sendWithPromise') || 
        errorMessage.includes('sendWithStream') ||
        errorMessage.includes('WorkerTransport') ||
        errorMessage.includes('getOptionalContentConfig') ||
        errorMessage.includes('getStructTree') ||
        errorMessage.includes('streamTextContent') ||
        errorMessage.includes('Cannot read properties of null')) {
      // Silently ignore - these are non-critical
      return;
    }
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

